// extracted by mini-css-extract-plugin
export var chevronIcon = "_9k-2";
export var teamName = "_9k-1";
export var teamSwitcherButton = "_9k-0";